/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { css, DefaultTheme } from 'styled-components';
import { TextFieldProps } from './TextField';

type FieldProps = {
  hasError?: boolean;
  success?: boolean;
  readOnly?: boolean;
  newPassword?: boolean;
} & Pick<TextFieldProps, 'disabled'>;

const fieldModifiers = {
  disabled: (theme: DefaultTheme) => css`
    background: ${theme.input.background};
    border: 1px solid ${theme.input.outline};
    color: ${theme.text.secondary};
    pointer-events: none;
  `,
  hasError: () => css`
    &,
    &:active,
    &:focus {
      border-color: ${'red'};
    }

    & + ${Label} {
      color: ${'red'};
    }
  `,
};

export const Container = styled.div<any>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

`;

export const InputWrapper = styled.div<FieldProps>`
  ${({ theme, disabled, hasError, readOnly }) => css`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background: ${theme.input.background};
    opacity: ${readOnly && 0.5};
    font-family: ${theme.typography.family.primary};
    font-weight: 500;
    border-radius: 4px;
    border: 1px solid ${theme.secondary};
    position: relative;
    width: 100%;
    text-align: left;
    height: 48px;
    min-height: 48px;
    outline: none;
    transition: all 0.2s linear;
    transition-property: color, border-color;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:active,
    &:focus-within {
      border-color: ${theme.primary};

      & > ${Label} {
        color: ${theme.input.label ?? theme.primary};
      }
    }

    &:disabled {
      background-color: ${theme.secondary};
      pointer-events: none;
    }

    ${hasError && fieldModifiers.hasError()};
    ${disabled && fieldModifiers.disabled(theme)};
    /* &:disabled {
      background-color: red;
    } */
  `}
`;

export const Field = styled.input`
  ${({ theme }) => css`
    appearance: none;
    background: none;
    border: none;
    font-family: inherit;
    font-size: ${theme.typography.sizes.base};
    line-height: ${theme.typography.lineHeight.base};
    color: ${theme.input.text};
    height: 48px;
    min-height: 48px;
    overflow: hidden;
    outline: none;
    padding: 10px 10px 0 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    &::placeholder {
      font-family: inherit;

      color: ${theme.text.secondary};
    }

    &:placeholder-shown {
      padding: ${theme.spacing.sm} 20px;

      & + ${Label} {
        top: 58%;
        opacity: 0;
        visibility: hidden;
      }
    }
  `}
`;

export const Label = styled.label`
  ${({ theme }) => css`
    color: ${theme.text.secondary ?? theme.primary};
    font-size: 10px;
    font-family: inherit;
    transition: all 0.2s linear;
    position: absolute;
    left: 21px;
    top: 10px;
    transform: translateY(-50%);
  `}
`;
export const Icon = styled.div`
  display: flex;
  position: relative;
  white-space: nowrap;
  height: 100%;
`;

export const IconContainer = styled(Icon)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${theme.spacing.xs};
    user-select: none;
  `}
`;

export const PasswordStreng = styled.div<{ step: number }>`
  ${({ theme, step = 0 }) => css`
    background-color: rgba(0, 0, 0, 0.2);
    margin: 8px auto 0;
    height: 4px;
    width: calc(100% - 40px);
    color: ${theme.primary};
    position: relative;

    &::after {
      content: '';
      background-color: ${theme.primary};
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      transition: width 0.2s linear;
      width: ${`${(step / 5) * 100}%` || '0%'};
    }
  `}
`;
